import { render, staticRenderFns } from "./xxjjzz.vue?vue&type=template&id=610ff2ba&scoped=true"
import script from "./xxjjzz.vue?vue&type=script&lang=js"
export * from "./xxjjzz.vue?vue&type=script&lang=js"
import style0 from "./xxjjzz.vue?vue&type=style&index=0&id=610ff2ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ff2ba",
  null
  
)

export default component.exports